import React from 'react';
import { Button } from './Button';
export const WeeklyBreakdownSection = () => {
  const checkoutUrl = 'https://www.neurotoned.com/offers/6oqdjPAT?coupon_code=7DAYRESETSPECIAL2025';
  return <section className="bg-gradient-to-b from-teal-600 to-teal-700 text-white py-16" data-id="element-392">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-393">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-394">
          Daily Breakdown
        </h2>
        <div className="mb-10" data-id="element-395">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iwqzNsRzr4qvCFatQsLDoL/Screen_Shot_2025-06-14_at_8.42.17_AM.png" alt="Daily course curriculum showing video lessons" className="w-full rounded-lg shadow-xl mb-8" data-id="element-396" />
        </div>
        <div className="grid md:grid-cols-2 gap-6 mb-10" data-id="element-397">
          <div className="bg-white bg-opacity-10 p-6 rounded-lg" data-id="element-398">
            <h3 className="text-xl font-bold mb-3" data-id="element-399">Day 1-2: Restore Safety</h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-400">
              <li data-id="element-401">Slow, trauma-informed yoga and breath</li>
              <li data-id="element-402">Gentle activation of the vagus nerve</li>
              <li data-id="element-403">Foundation for calm</li>
            </ul>
          </div>
          <div className="bg-white bg-opacity-10 p-6 rounded-lg" data-id="element-404">
            <h3 className="text-xl font-bold mb-3" data-id="element-405">
              Day 3-4: Unfreeze Your Body
            </h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-406">
              <li data-id="element-407">Movement meets sound and sensory mapping</li>
              <li data-id="element-408">Tools to safely exit shutdown and dissociation</li>
            </ul>
          </div>
          <div className="bg-white bg-opacity-10 p-6 rounded-lg" data-id="element-409">
            <h3 className="text-xl font-bold mb-3" data-id="element-410">
              Day 5-6: Reconnect & Express
            </h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-411">
              <li data-id="element-412">Expressive arts and voice activation</li>
              <li data-id="element-413">Release emotional blocks with movement, not words</li>
            </ul>
          </div>
          <div className="bg-white bg-opacity-10 p-6 rounded-lg" data-id="element-414">
            <h3 className="text-xl font-bold mb-3" data-id="element-415">Day 7: Regulate & Rewire</h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-416">
              <li data-id="element-417">Build daily resilience habits</li>
              <li data-id="element-418">
                Develop a personal nervous system toolkit for long-term use
              </li>
            </ul>
          </div>
        </div>
        <p className="text-center text-lg mb-6" data-id="element-419">
          Already Know The Science? Now You'll Feel the Shift — With Just One
          Week of Daily Body-Based Practice.
        </p>
        <div className="flex justify-center" data-id="element-420">
          <Button link={checkoutUrl} data-id="element-421">Try the 7-Day Reset – Just $9 ➔</Button>
        </div>
      </div>
    </section>;
};